<script>
import Swal from "sweetalert2";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { VueEditor } from "vue2-editor";

import { required } from "vuelidate/lib/validators";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Drawer from "vue-simple-drawer";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrIcDegerGiris from "@/models/StrIcDegerGiris";
import moment from "moment";
import StrKontrolGirisKanit from "../../StrKurumsalPerformans/StrKontrolGirisKanit/AddEdit.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import store from "@/state/store";

class Base64UploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  upload() {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      this.loader.file
        .then((file) => {
          reader.readAsDataURL(file);
          reader.onload = () => resolve({ default: reader.result });
          reader.onerror = (error) => reject(error);
        })
        .catch((error) => reject(error));
    });
  }

  abort() {}
}

export default {
  mixins: [Api, Sabit, StrIcDegerGiris],
  page: {
    title: "Kalite Öz Değerlendirme Veri Giriş",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Drawer,
    Layout,
    PageHeader,
    formcombobox,
    StrKontrolGirisKanit,
    ckeditor: CKEditor.component,
    BirimSecimi,
    VueEditor,
  },
  data() {
    return {
      lineHeight: 1.0,
      editorOptions: {
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ script: "sub" }, { script: "super" }],
            ["blockquote", "code-block"],
            [
              { list: "ordered" },
              { list: "bullet" },
              { indent: "-1" },
              { indent: "+1" },
            ],
            [{ direction: "rtl" }, { align: [] }],
            ["link", "image", "video"],
            ["clean"],
          ],
        },
      },
      title: this.$t("StrIcDegerGiris.Title"),
      items: [
        {
          text: this.$t("StrIcDegerGiris.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrIcDegerGiris.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrIcDegerGiris.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      Page2: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Message: {
        position: "",
        icon: "",
        title: "",
        showConfirmButton: false,
        timer: 1500,
      },
      KullaniciBilgileri: null,
      AltKayitKontrol: false,
      FormData: {},
      FilitrelemePenceresi: false,
      kayit_kontrol: null,
      TableData: [],
      TableDataAlt: [],
      DataUpdate: "",
      AddEdit: "",
      DonemAdi: "",
      DonemCombobox: [],
      BirimIdCombobox: [],
      AnaBaslikCombobox: [],
      AltBaslikCombobox: [],
      Raporgirisid: null,
      Kontrolgirisid: null,
      Userid: "",
      Filter: {
        Donem: null,
        BirimId: null,
        AnaBaslik: null,
        AltBaslik: null,
        Degerlendirmetur: 1,
      },
      Degerlendirmeturleri: [
        { Id: "1", Value: "Kalite Öz Değerlendirme" },
        { Id: "2", Value: "Akran Değerlendirme" },
        { Id: "3", Value: "Program Öz Değerlendirme" },
        { Id: "4", Value: "İç Değerlendirme" },
      ],
      DegerlendirmeturleriCombobox: [],
      editorData: "",
      StrIcDegerGirisData: [],
      Icdegergirisid: "",
      editor: ClassicEditor,

      CkeditorModel: [],
      editorConfig: {
        extraPlugins: [
          function Base64AdapterPlugin(editor) {
            editor.plugins.get("FileRepository").createUploadAdapter = (
              loader
            ) => {
              return new Base64UploadAdapter(loader);
            };
          },
        ],

        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "link",
          "blockQuote",
          "codeBlock",
          "imageUpload",
          "insertTable",
          "mediaEmbed",
          "numberedList",
          "bulletedList",
          "outdent",
          "indent",
          "|",
          "undo",
          "redo",
          "alignment",
          "fontSize",
          "fontColor",
          "fontBackgroundColor",
          "lineHeight",
        ],
      },
    };
  },
  computed: {
    editorStyle() {
      return {
        "--line-height": this.lineHeight,
      };
    },
  },
  validations: {
    Filter: {
      Donem: { required },
      BirimId: { required },
      AnaBaslik: { required },
      AltBaslik: {},
      Degerlendirmetur: { required },
    },
  },
  methods: {
    setLineHeight(height) {
      this.lineHeight = height;
      this.applyLineHeight();
    },
    applyLineHeight() {
      this.$nextTick(() => {
        const editorElement = document.querySelector(
          ".custom-editor .ql-editor"
        );
        if (!editorElement) return;
        const value = String(this.lineHeight);

        // root'a da uygula (fallback)
        editorElement.style.lineHeight = value;

        // ve tüm blok elemanlara uygula (içerik yeniden renderlense bile daha kalıcı)
        const nodes = editorElement.querySelectorAll(
          "p, div, li, td, h1, h2, h3, h4, h5, h6"
        );
        nodes.forEach((el) => {
          el.style.lineHeight = value;
        });
      });
    },
    mounted() {
      // Bileşen yüklendiğinde satır yüksekliğini uygula
      this.$nextTick(() => {
        this.applyLineHeight();
      });
    },
    Get() {
      this.KullaniciBilgileri = store.getters["auth/UserRolles"];
      this.FormData = this.IcDegerGirisData;
    },
    FilterGet() {
      this.TableData = [];
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.CkeditorModel = [];
        this.DonemAdi = this.DonemCombobox.filter((notification) =>
          notification.Id.includes(this.Filter.Donem)
        )[0].Value;

        let Filter =
          "&DonemId=" +
          this.Filter.Donem +
          "&BirimId=" +
          this.Filter.BirimId +
          "&DetayId=" +
          this.Filter.AnaBaslik;
        this.ActionsFilterGet({
          Service: "StrIcDegerGiris/GetVeriGirisFormu",
          Page: this.Page,
          Filter: Filter,
        }).then((res) => {
          this.TableData = [];
          if (res.Data[0]) {
            this.TableData = res.Data[0];
            this.Page.PageDataSize = res.TotalCount;
          }

          this.StrIcDegerGirisGet();
        });
        this.FilitrelemePenceresi = false;
      }
    },
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
    AltBaslikSecim() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      let Filter = "&Ustid=" + this.Filter.AnaBaslik;
      this.AltBaslikCombobox = [];
      this.ActionsFilterGet({
        Service: "StrIcDegerTablo",
        Page: Page,
        Filter: Filter,
      }).then((res) => {
        for (var i = 0; i < res.Data.length; i++) {
          this.AltBaslikCombobox.push({
            Id: res.Data[i].Id,
            Value: res.Data[i].Tabloadi,
          });
        }
      });
    },
    PostUpdate(index, TabloUstId, TabloId) {
      let Kontrol = true;
      let KayitKontrol = this.StrIcDegerGirisData[0].Tablolar.filter(
        (notification) => notification.TabloId.includes(TabloUstId)
      )[0];
      if (KayitKontrol) {
        KayitKontrol = KayitKontrol.Tablolar.filter((notification) =>
          notification.TabloId.includes(TabloId)
        )[0];

        if (KayitKontrol) {
          if (KayitKontrol.Giris.Id == "00000000-0000-0000-0000-000000000000") {
            Kontrol = false;
          }
        } else {
          Kontrol = false;
        }
      } else {
        Kontrol = false;
      }

      if (Kontrol) {
        this.FormData = KayitKontrol.Giris;
        this.FormData.Deger = this.CkeditorModel[index].Deger;
        this.Update("StrIcDegerGiris", this.FormData).then((res) => {
          if (res) {
            this.StrIcDegerGirisGet();
            this.FilterGet();
          }
        });
      } else {
        this.FormData.Deger = this.CkeditorModel[index].Deger;
        this.FormData.Donemid = this.Filter.Donem;
        this.FormData.Birimid = this.Filter.BirimId;
        this.FormData.Detayid = TabloId;
        this.Post("StrIcDegerGiris", this.FormData).then((res) => {
          if (res) {
            this.StrIcDegerGirisGet();
            this.FilterGet();
          }
        });
      }
    },

    StrIcDegerGirisGet() {
      this.StrIcDegerGirisData = [];
      let Filter =
        "&Donemid=" +
        this.Filter.Donem +
        "&Birimid=" +
        this.Filter.BirimId +
        "&DetayId=" +
        this.Filter.AnaBaslik;
      this.ActionsFilterGet({
        Service: "StrIcDegerGiris",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.StrIcDegerGirisData = res.Data;
      });
    },

    OnayHazir(TabloUstId, TabloId) {
      if (TabloUstId || TabloId) {
        let durum = true;
        if (this.StrIcDegerGirisData[0]) {
          let KayitKontrol = this.StrIcDegerGirisData[0].Tablolar.filter(
            (notification) => notification.TabloId.includes(TabloUstId)
          )[0];
          if (KayitKontrol) {
            let Tablo = KayitKontrol.Tablolar;
            for (var i = 0; i < Tablo.length; i++) {
              if (Tablo[i].Giris.Id == "00000000-0000-0000-0000-000000000000") {
                durum = false;
              }
            }
          }
          return durum;
        }
      }
    },
    OnayKontrol(TabloUstId, TabloId) {
      if (TabloUstId || TabloId) {
        let durum = true;
        if (this.StrIcDegerGirisData[0]) {
          let KayitKontrol = this.StrIcDegerGirisData[0].Tablolar.filter(
            (notification) => notification.TabloId.includes(TabloUstId)
          )[0];
          if (KayitKontrol) {
            let Tablo = KayitKontrol.Tablolar;
            for (var i = 0; i < Tablo.length; i++) {
              if (Tablo[i].Giris.Onay == null || Tablo[i].Giris.Onay == 0) {
                durum = false;
              }
            }
          }
        }
        return durum;
      }
    },
    StrIcDegerGirisOnay(TabloUstId, TabloId, Islem) {
      if (TabloUstId || TabloId) {
        let durum = true;
        let KayitKontrol = this.StrIcDegerGirisData[0].Tablolar.filter(
          (notification) => notification.TabloId.includes(TabloUstId)
        )[0];
        let Tablo = KayitKontrol.Tablolar;
        let Onay = 1;
        if (Islem != "Onayla") {
          Onay = 0;
        }
        for (var i = 0; i < Tablo.length; i++) {
          let FormData = {
            Id: Tablo[i].Giris.Id,
            Onay: Onay,
            Deger: Tablo[i].Giris.Deger,
            Birimid: Tablo[i].Giris.BirimId,
            Detayid: Tablo[i].Giris.DetayId,
            Donemid: Tablo[i].Giris.DonemId,
            Olgunluk: Tablo[i].Giris.Olgunluk,
          };

          this.Update("StrIcDegerGiris", FormData);
          this.FilterGet();
        }
        return durum;
      }
    },
    OlgunlukSecim(FormData) {
      this.kayit_kontrol = null;
      if (FormData.Id == "00000000-0000-0000-0000-000000000000") {
        let FormDatanew = {
          Deger: FormData.Deger,
          Olgunluk: FormData.Olgunluk,
          DonemId: FormData.DonemId,
          BirimId: FormData.BirimId,
          DetayId: FormData.DetayId,
        };
        this.Post("StrIcDegerGiris", FormDatanew).then((res) => {
          if (res) {
            // this.FilterGet();
            FormData.Id = res.Data;
          }
        });
      } else {
        this.Update("StrIcDegerGiris", FormData).then((res) => {
          if (res) {
            // this.FilterGet();
          }
        });
      }
    },
    DegerKayit(FormData) {
      if (FormData.Id == "00000000-0000-0000-0000-000000000000") {
        let FormDatanew = {
          Deger: FormData.Deger,
          DonemId: FormData.DonemId,
          BirimId: FormData.BirimId,
          DetayId: FormData.DetayId,
        };
        this.Post("StrIcDegerGiris", FormDatanew).then((res) => {
          if (res) {
            this.FilterGet();
          }
        });
      } else {
        this.Update("StrIcDegerGiris", FormData).then((res) => {
          if (res) {
            this.FilterGet();
          }
        });
      }
    },
    DegerlendirmeTureGoreBaslik() {
      this.ActionsFilterGet({
        Service: "StrIcDegerTablo",
        Page: this.Page2,
        Filter: "&Seviye=0&Degerlendirmetur=" + this.Filter.Degerlendirmetur,
      }).then((res) => {
        const filteredData = res.Data.filter((item) => item.Ustid === null);
        filteredData.sort((a, b) => a.Sirano - b.Sirano);
        this.AnaBaslikCombobox = filteredData.map((item) => ({
          Id: item.Id,
          Value: item.Tabloadi,
        }));
      });
    },
    GetBolumProgram() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      let Filter = "&Kisaadi=STR";
      if (
        this.Filter.Degerlendirmetur == 2 ||
        this.Filter.Degerlendirmetur == 3
      ) {
        let Birimtip = this.Filter.Degerlendirmetur == 2 ? "Bölüm" : "Program";
        this.ActionsFilterGet({
          Service: "Ouygulama",
          Page: Page,
          Filter: Filter,
        }).then((res) => {
          if (res) {
            this.ActionsFilterGet({
              Service: "obirimtip",
              Page: Page,
              Filter: "&Birimtipadi=" + Birimtip,
            }).then((respo) => {
              this.ActionsFilterGet({
                Service: "OUserBirimYetki",
                Page: Page,
                Filter:
                  "&Userid=" +
                  this.Userid +
                  "&Uygulamaid=" +
                  res.Data[0].Id +
                  "&Birimtipid=" +
                  respo.Data[0].Id,
              }).then((resp) => {
                this.BirimIdCombobox = [];
                for (var i = 0; i < resp.Data.length; i++) {
                  this.BirimIdCombobox.push({
                    Id: resp.Data[i].Birimid,
                    Value: resp.Data[i].Birimadi,
                  });
                }
              });
            });
          }
        });
      }
    },
    openModal(id) {
      if (id == "00000000-0000-0000-0000-000000000000") {
        Swal.fire({
          title: "Uyarı!",
          text: "Öncelikle değerlendirmeyi kaydetmelisiniz!",
          icon: "warning",
        });
      } else {
        // Kontrol geçerse, modalı aç
        this.Icdegergirisid = id;
        this.$bvModal.show("StrKontrolGirisKanit"); // v-b-modal yerine programlı açım
      }
    },
  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
    this.ActionsFilterGet({
      Service: "OKeyValues",
      Page: Page,
      Filter: "&Tip=1561&Kod=7",
    }).then((resp) => {
      this.ActionsFilterGet({
        Service: "StrPerfDonem",
        Page: Page,
        Filter:
          "&Approval=true&UstIdDoluMu=true&TipId=" +
          resp.Data[0].Id +
          "&VeriTipi=3",
      }).then((res) => {
        let Tarih = moment(new Date()).format("YYYY-MM-DD");
        for (var i = 0; i < res.Data.length; i++) {
          if (
            this.$options.filters.formatDate(res.Data[i].BaslamaTarihi) <=
              Tarih &&
            Tarih <= this.$options.filters.formatDate(res.Data[i].BitisTarihi)
          ) {
            this.DonemCombobox.push({
              Id: res.Data[i].Id,
              Value: res.Data[i].Aciklama,
            });
          }
        }
      });
    });
    this.Userid = store.getters["auth/TokenUserId"];

        this.ActionsFilterGet({
      Service: "StrParam",
      Page: Page,
      Filter: "&Tip=7",
    }).then((res) => {
      if(res.Data[0].Value == 1){
          this.Degerlendirmeturleri =  [{ Id: "1", Value: "Birim Öz Değerlendirme" }]
        }
    });
    this.DegerlendirmeTureGoreBaslik();
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="row">
                    <div style="margin-top: -7px;" class="col-md-6">
                      <formcombobox
                        :FormDataType="{
                          FieldName: 'Degerlendirmetur',
                          Field: 'combobox',
                          FieldTitle: $t(
                            'StrIcDegerGiris.Filtreleme.Degerlendirmetur'
                          ),
                          ComboDataArray: Degerlendirmeturleri,
                        }"
                        :Value="Filter.Degerlendirmetur"
                        :v="$v.Filter.Degerlendirmetur"
                        @input="
                          (Filter.Degerlendirmetur = $event),
                            DegerlendirmeTureGoreBaslik(),
                            GetBolumProgram()
                        "
                      />
                    </div>

                    <div
                      style="margin-top: -7px;"
                      class="col-md-6"
                      v-if="
                        Filter.Degerlendirmetur == 1 ||
                          Filter.Degerlendirmetur == 4
                      "
                    >
                      <BirimSecimi
                        :title="$t('StrIcDegerGiris.Filtreleme.BirimId')"
                        :sutun="'0'"
                        :title_position="'mb-3'"
                        :selected="Filter.BirimId"
                        :YetkiKontrol="1"
                        :labels_lg="'3'"
                        :multiple="false"
                        :BirimTipId="null"
                        @Secilmis_Idler="Filter.BirimId = $event"
                      />
                    </div>

                    <div style="margin-top: -7px;" class="col-md-6" v-else>
                      <formcombobox
                        :FormDataType="{
                          FieldName: 'Birimler',
                          Field: 'combobox',
                          FieldTitle: $t('StrIcDegerGiris.Filtreleme.BirimId'),
                          ComboDataArray: BirimIdCombobox,
                        }"
                        :Value="Filter.BirimId"
                        :v="$v.Filter.BirimId"
                        @input="Filter.BirimId = $event"
                      />
                    </div>

                    <div style="margin-top: -7px;" class="col-md-6">
                      <formcombobox
                        :FormDataType="{
                          FieldName: 'Donem',
                          Field: 'combobox',
                          FieldTitle: $t('StrIcDegerGiris.Filtreleme.Donem'),
                          ComboDataArray: DonemCombobox,
                        }"
                        :Value="Filter.Donem"
                        :v="$v.Filter.Donem"
                        @input="Filter.Donem = $event"
                      />
                    </div>

                    <div style="margin-top: -7px;" class="col-md-6">
                      <formcombobox
                        :FormDataType="{
                          FieldName: 'AnaBaslik',
                          Field: 'combobox',
                          FieldTitle: $t(
                            'StrIcDegerGiris.Filtreleme.AnaBaslik'
                          ),
                          ComboDataArray: AnaBaslikCombobox,
                        }"
                        :Value="Filter.AnaBaslik"
                        :v="$v.Filter.AnaBaslik"
                        @input="(Filter.AnaBaslik = $event), AltBaslikSecim()"
                      />
                    </div>
                  </div>

                  <b-button
                    @click="FilterGet()"
                    class="btn btn-primary"
                    variant="primary"
                    >{{ $t("StrIcDegerGiris.Filtreleme.Button") }}</b-button
                  >
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button
                      type="button"
                      class="btn btn-secondary btn-rounded mb-2 me-2"
                      @click="rightDrawer"
                      v-if="0 == 1"
                    >
                      <i class="mdi mdi-text-search me-1"></i>
                      {{ $t("StrIcDegerGiris.Page.Filtreleme") }}
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="TableData">
                <div
                  class="table-responsive"
                  v-for="(TableVerileri, Tabloindex) in TableData.Tablolar"
                  :key="Tabloindex"
                >
                  <table
                    class="table table-striped table-bordered mb-0"
                    v-if="TableVerileri.Tablolar.length != 0"
                  >
                    <thead class="table-light">
                      <tr>
                        <th>{{ $t("StrIcDegerGiris.Table.TabloAdi") }}</th>
                        <th>{{ TableVerileri.TabloAdi }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colspan="3">
                          <table
                            class="table table-striped table-bordered mb-0"
                            style="border: 2px solid #323748;"
                          >
                            <thead
                              class="table-light"
                              v-for="(Tablolar,
                              index) in TableVerileri.Tablolar"
                              :key="index"
                            >
                              <tr v-if="index == 0">
                                <th>
                                  {{ $t("StrIcDegerGiris.Table.Olcutler") }}
                                </th>
                                <th>
                                  {{ DonemAdi }}

                                  <br />
                                  <br />
                                  <i
                                    class="fas fa-exclamation"
                                    v-if="
                                      OnayHazir(
                                        TableVerileri.TabloId,
                                        Tablolar.TabloId
                                      ) == false
                                    "
                                  >
                                    {{ $t("StrIcDegerGiris.Table.VeriEksik") }}
                                  </i>
                                  <i
                                    class="mdi mdi-check-all me-1"
                                    @click="
                                      StrIcDegerGirisOnay(
                                        TableVerileri.TabloId,
                                        Tablolar.TabloId,
                                        'Onayla'
                                      )
                                    "
                                    v-if="
                                      OnayKontrol(
                                        TableVerileri.TabloId,
                                        Tablolar.TabloId
                                      ) == false &&
                                        OnayHazir(
                                          TableVerileri.TabloId,
                                          Tablolar.TabloId
                                        ) &&
                                        RolesControl(
                                          KullaniciBilgileri,
                                          'StrKaliteOnay'
                                        )
                                    "
                                  >
                                    {{ $t("StrIcDegerGiris.Table.Onayla") }}
                                  </i>
                                  <i
                                    class="mdi mdi-close me-1"
                                    @click="
                                      StrIcDegerGirisOnay(
                                        TableVerileri.TabloId,
                                        Tablolar.TabloId,
                                        'OnayIptal'
                                      )
                                    "
                                    v-else-if="
                                      OnayKontrol(
                                        TableVerileri.TabloId,
                                        Tablolar.TabloId
                                      ) &&
                                        OnayHazir(
                                          TableVerileri.TabloId,
                                          Tablolar.TabloId
                                        ) &&
                                        RolesControl(
                                          KullaniciBilgileri,
                                          'StrKaliteOnay'
                                        )
                                    "
                                  >
                                    {{ $t("StrIcDegerGiris.Table.OnayIptal") }}
                                  </i>
                                </th>
                                <th>{{ $t("StrIcDegerGiris.Table.Detay") }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(Tablolar,
                                index) in TableVerileri.Tablolar"
                                :key="index"
                              >
                                <th scope="row">{{ Tablolar.TabloAdi }}</th>
                                <td>
                                  <table
                                    class="table table-striped table-bordered mb-0"
                                  >
                                    <thead class="table-light">
                                      <tr>
                                        <th colspan="5">
                                          {{ Tablolar.Aciklama }}
                                        </th>
                                      </tr>
                                    </thead>
                                    <thead
                                      class="table-light"
                                      v-if="
                                        !(
                                          TableVerileri.UstId ==
                                            'c25ff26b-245d-4f1e-b48d-9e07e50607ad' ||
                                          TableVerileri.UstId ==
                                            'ab263f6a-bc17-4580-8896-003ddc602603'
                                        ) && Tablolar.Olgunlukvarmi
                                      "
                                    >
                                      <tr>
                                        <th>Olgunluk 1</th>
                                        <th>Olgunluk 2</th>
                                        <th>Olgunluk 3</th>
                                        <th>Olgunluk 4</th>
                                        <th>Olgunluk 5</th>
                                      </tr>
                                    </thead>
                                    <tbody
                                      v-if="
                                        !(
                                          TableVerileri.UstId ==
                                            'c25ff26b-245d-4f1e-b48d-9e07e50607ad' ||
                                          TableVerileri.UstId ==
                                            'ab263f6a-bc17-4580-8896-003ddc602603'
                                        ) && Tablolar.Olgunlukvarmi
                                      "
                                    >
                                      <tr>
                                        <td>
                                          <b-form-group>
                                            <b-form-radio
                                              class="mb-3"
                                              :value="Tablolar.Olgunluk1"
                                              plain
                                              v-model="Tablolar.Giris.Olgunluk"
                                              :name="
                                                'olgunluk' +
                                                  Tablolar.Giris.DetayId
                                              "
                                            ></b-form-radio
                                          ></b-form-group>
                                          {{ Tablolar.Olgunluk1 }}
                                        </td>
                                        <td>
                                          <b-form-group>
                                            <b-form-radio
                                              class="mb-3"
                                              :value="Tablolar.Olgunluk2"
                                              plain
                                              v-model="Tablolar.Giris.Olgunluk"
                                              :name="
                                                'olgunluk' +
                                                  Tablolar.Giris.DetayId
                                              "
                                            ></b-form-radio
                                          ></b-form-group>
                                          {{ Tablolar.Olgunluk2 }}
                                        </td>
                                        <td>
                                          <b-form-group>
                                            <b-form-radio
                                              class="mb-3"
                                              :value="Tablolar.Olgunluk3"
                                              plain
                                              v-model="Tablolar.Giris.Olgunluk"
                                              :name="
                                                'olgunluk' +
                                                  Tablolar.Giris.DetayId
                                              "
                                            ></b-form-radio
                                          ></b-form-group>
                                          {{ Tablolar.Olgunluk3 }}
                                        </td>
                                        <td>
                                          <b-form-group>
                                            <b-form-radio
                                              class="mb-3"
                                              :value="Tablolar.Olgunluk4"
                                              plain
                                              v-model="Tablolar.Giris.Olgunluk"
                                              :name="
                                                'olgunluk' +
                                                  Tablolar.Giris.DetayId
                                              "
                                            ></b-form-radio
                                          ></b-form-group>
                                          {{ Tablolar.Olgunluk4 }}
                                        </td>
                                        <td>
                                          <b-form-group>
                                            <b-form-radio
                                              class="mb-3"
                                              :value="Tablolar.Olgunluk5"
                                              plain
                                              v-model="Tablolar.Giris.Olgunluk"
                                              :name="
                                                'olgunluk' +
                                                  Tablolar.Giris.DetayId
                                              "
                                            ></b-form-radio
                                          ></b-form-group>
                                          {{ Tablolar.Olgunluk5 }}
                                        </td>
                                      </tr>
                                    </tbody>
                                    <thead class="table-light">
                                      <tr>
                                        <th colspan="5">
                                          <span style="max-width: 200px;"
                                            >Değer</span
                                          >
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td
                                          colspan="5"
                                          style="max-width: 800px;"
                                        >
                                          <!--CK editörü parametre sorunları sebebiyle kaldırdım-->
                                          <ckeditor
                                            v-if="1 == 5"
                                            v-model="Tablolar.Giris.Deger"
                                            :editor="editor"
                                            :config="editorConfig"
                                            :disabled="Tablolar.Giris.Onay == 1"
                                          ></ckeditor>

                                          <div
                                            class="custom-editor"
                                            :style="editorStyle"
                                          >
                                            <vue-editor
                                              v-model="Tablolar.Giris.Deger"
                                              class="custom-editor"
                                            ></vue-editor>
                                            <div class="controls">
                                              <span> Line Heigth : </span>
                                              <button
                                                @click="setLineHeight(1.0)"
                                              >
                                                1.0
                                              </button>
                                              <button
                                                @click="setLineHeight(1.5)"
                                              >
                                                1.5
                                              </button>
                                              <button
                                                @click="setLineHeight(2.0)"
                                              >
                                                2.0
                                              </button>
                                              <button
                                                @click="setLineHeight(2.5)"
                                              >
                                                2.5
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td>
                                  <i
                                    class="mdi mdi-clipboard-edit-outline me-1"
                                    @click="openModal(Tablolar.Giris.Id)"
                                  >
                                    {{ $t("StrIcDegerGiris.Table.Kanit") }}
                                  </i>

                                  <br />

                                  <button
                                    class="btn btn-primary"
                                    @click="OlgunlukSecim(Tablolar.Giris)"
                                    v-if="Tablolar.Giris.Onay != 1"
                                  >
                                    Değerlendirme Kaydet
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <StrKontrolGirisKanit
        :Icdegergirisid="Icdegergirisid"
        :Raporgirisid="Raporgirisid"
        :Kontrolgirisid="Kontrolgirisid"
      />

      <Drawer
        @close="rightDrawer"
        :align="'right'"
        :closeable="true"
        :maskClosable="true"
        :zIndex="1002"
      >
        <div style="width: 400px;" v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrIcDegerGiris.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("StrIcDegerGiris.Filtreleme.Content") }}
            <br /><br />
            <div class="mb-3">
              <BirimSecimi
                :title="$t('StrIcDegerGiris.Filtreleme.BirimId')"
                :sutun="'0'"
                :title_position="'mb-3'"
                :selected="Filter.BirimId"
                :YetkiKontrol="1"
                :labels_lg="'3'"
                :multiple="false"
                :BirimTipId="null"
                @Secilmis_Idler="Filter.BirimId = $event"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Donem',
                  Field: 'combobox',
                  FieldTitle: $t('StrIcDegerGiris.Filtreleme.Donem'),
                  ComboDataArray: DonemCombobox,
                }"
                :Value="Filter.Donem"
                :v="$v.Filter.Donem"
                @input="Filter.Donem = $event"
              />
            </div>

            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'AnaBaslik',
                  Field: 'combobox',
                  FieldTitle: $t('StrIcDegerGiris.Filtreleme.AnaBaslik'),
                  ComboDataArray: AnaBaslikCombobox,
                }"
                :Value="Filter.AnaBaslik"
                :v="$v.Filter.AnaBaslik"
                @input="(Filter.AnaBaslik = $event), AltBaslikSecim()"
              />
            </div>

            <b-button
              @click="FilterGet()"
              class="btn btn-primary"
              variant="primary"
              >{{ $t("StrIcDegerGiris.Filtreleme.Button") }}</b-button
            >
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
<style>
.mdi-check-all {
  color: white;
  background-color: #556ee6;
  padding: 8px;
  margin-top: 25px;
  border-radius: 4px;
}
.mdi-close {
  color: white;
  background-color: #e63946;
  padding: 8px;
  margin-top: 25px;
  border-radius: 4px;
}
.fa-exclamation {
  color: white;
  background-color: #e63946;
  padding: 4px;
  border-radius: 4px;
}
</style>

<style scoped>
.custom-editor {
  /* Container stilleri */
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: #fff;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.custom-editor >>> .ql-toolbar {
  /* Toolbar stilleri */
  border: none;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
  padding: 12px 16px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.custom-editor >>> .ql-toolbar .ql-formats {
  /* Toolbar buton grupları */
  margin-right: 16px;
}

.custom-editor >>> .ql-toolbar button {
  /* Toolbar butonları */
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 4px 8px;
  margin: 2px;
  transition: all 0.2s ease;
}

.custom-editor >>> .ql-toolbar button:hover {
  background: #e9ecef;
  border-color: #dee2e6;
}

.custom-editor >>> .ql-toolbar button.ql-active {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

.custom-editor >>> .ql-container {
  /* Editor container */
  border: none;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
}

.custom-editor >>> .ql-editor {
  min-height: 300px;
  max-height: 600px;
  overflow-y: auto;
  padding: 20px;
  line-height: var(--line-height, 1.6); /* burada değişken kullanılıyor */
  color: #333;
  background: #fff;
}

.custom-editor >>> .ql-editor.ql-blank::before {
  /* Placeholder stili */
  color: #6c757d;
  font-style: italic;
  font-size: 14px;
  left: 20px;
  right: 20px;
}

.custom-editor >>> .ql-editor p {
  /* Paragraf stilleri */
  margin-bottom: 1em;
  font-size: 14px;
  line-height: 1.6;
}

.custom-editor >>> .ql-editor h1,
.custom-editor >>> .ql-editor h2,
.custom-editor >>> .ql-editor h3,
.custom-editor >>> .ql-editor h4,
.custom-editor >>> .ql-editor h5,
.custom-editor >>> .ql-editor h6 {
  /* Başlık stilleri */
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.3;
  color: #2c3e50;
}

.custom-editor >>> .ql-editor h1 {
  font-size: 2em;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 0.3em;
}

.custom-editor >>> .ql-editor h2 {
  font-size: 1.75em;
}

.custom-editor >>> .ql-editor h3 {
  font-size: 1.5em;
}

.custom-editor >>> .ql-editor h4 {
  font-size: 1.25em;
}

.custom-editor >>> .ql-editor h5 {
  font-size: 1.1em;
}

.custom-editor >>> .ql-editor h6 {
  font-size: 1em;
  color: #6c757d;
}

.custom-editor >>> .ql-editor blockquote {
  /* Alıntı stilleri */
  border-left: 4px solid #007bff;
  background: #f8f9fa;
  padding: 12px 20px;
  margin: 16px 0;
  font-style: italic;
  color: #495057;
}

.custom-editor >>> .ql-editor ul,
.custom-editor >>> .ql-editor ol {
  /* Liste stilleri */
  padding-left: 24px;
  margin: 12px 0;
}

.custom-editor >>> .ql-editor li {
  /* Liste öğeleri */
  margin-bottom: 4px;
  line-height: 1.5;
}

.custom-editor >>> .ql-editor a {
  /* Link stilleri */
  color: #007bff;
  text-decoration: underline;
  transition: color 0.2s ease;
}

.custom-editor >>> .ql-editor a:hover {
  color: #0056b3;
}

.custom-editor >>> .ql-editor code {
  /* Inline kod stilleri */
  background: #f1f3f4;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: "Courier New", monospace;
  font-size: 0.9em;
  color: #e83e8c;
}

.custom-editor >>> .ql-editor .ql-code-block-container {
  /* Kod blokları */
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 16px;
  margin: 16px 0;
  font-family: "Courier New", monospace;
  font-size: 0.9em;
}

.custom-editor >>> .ql-editor .ql-align-center {
  /* Ortalanmış içerik */
  text-align: center;
}

.custom-editor >>> .ql-editor .ql-align-right {
  /* Sağa yaslı içerik */
  text-align: right;
}

.custom-editor >>> .ql-editor .ql-align-justify {
  /* İki yana yaslı içerik */
  text-align: justify;
}

/* Responsive tasarım */
@media (max-width: 768px) {
  .custom-editor {
    margin: 0 10px;
    border-radius: 6px;
  }

  .custom-editor >>> .ql-toolbar {
    padding: 8px 12px;
  }

  .custom-editor >>> .ql-editor {
    padding: 16px;
    min-height: 250px;
    font-size: 16px; /* Mobile için font büyütme */
  }

  .custom-editor >>> .ql-toolbar .ql-formats {
    margin-right: 8px;
  }
}

/* Karanlık tema desteği */
@media (prefers-color-scheme: dark) {
  .custom-editor {
    background: #2d3748;
    border-color: #4a5568;
    color: #e2e8f0;
  }

  .custom-editor >>> .ql-toolbar {
    background: #4a5568;
    border-bottom-color: #718096;
  }

  .custom-editor >>> .ql-editor {
    background: #2d3748;
    color: #e2e8f0;
  }

  .custom-editor >>> .ql-editor.ql-blank::before {
    color: #a0aec0;
  }
}
</style>
